export const NEIGHBOR_CREATE_START = 'NEIGHBOR_CREATE_START'
export const NEIGHBOR_CREATE_END = 'NEIGHBOR_CREATE_END'
export const NEIGHBORS_LOAD_START = 'NEIGHBORS_LOAD_START'
export const NEIGHBORS_LOAD_END = 'NEIGHBORS_LOAD_END'
